require('jquery')

jQuery(function ($) {
  $('form[name="vde-product-attributes-form"]').on(
    'change',
    'input[type="radio"], input[type="checkbox"]',
    function () {
      $(this).closest('form').submit()
    }
  )
})
